import React from 'react';
import {FieldValues} from 'react-hook-form';
import TitleBar, {TitleBarProps} from 'shared/migration-components/title-bar';

import {Container} from './styles';
import Form, {FormProps} from 'shared/migration-components/form';
import useApiQuery from 'shared/hooks/use-api-query';
import Loading from 'shared/migration-components/loading';
import {ButtonProps} from 'shared/migration-components/button';

interface EditionProps<T extends FieldValues, D = T>
  extends Omit<FormProps<T>, 'extraButtons' | 'disabled'> {
  titleBar?: TitleBarProps;
  detailsUrl: string;
  queryKey?: any;
  handleDefaultValues?: (data: D) => T;
  extraButtons?: (data: T) => (ButtonProps | React.ReactNode)[];
  disabled?: (data: T) => boolean;
}

const Edition: <T extends FieldValues, D = any>(
  P: EditionProps<T, D>,
) => React.ReactElement<T> = ({
  titleBar,
  detailsUrl,
  queryKey,
  handleDefaultValues,
  extraButtons,
  disabled,
  ...props
}) => {
  const detailsQuery = useApiQuery({url: detailsUrl, queryKey});

  return (
    <Container>
      {titleBar && <TitleBar {...titleBar} />}
      {detailsQuery.isLoading && <Loading />}
      {!detailsQuery.isLoading && (
        <Form
          {...{
            ...props,
            disabled: disabled ? disabled(detailsQuery.data) : undefined,
            extraButtons: extraButtons
              ? extraButtons(detailsQuery.data)
              : undefined,
            defaultValues: handleDefaultValues
              ? handleDefaultValues(detailsQuery.data)
              : detailsQuery.data,
          }}
        />
      )}
    </Container>
  );
};

export default Edition;
